module.exports = __webpack_public_path__ + "static/media/Warwick.ffd8d8f6.png";